__turbopack_context__.v({
  "line": "LineDivider-module__78_QAa__line",
  "root": "LineDivider-module__78_QAa__root",
});
